import Button from "lib/components/Button"
import Image from "lib/components/Image"
import Text from "lib/components/Text"

export interface NotFoundTitleProps {
  title: string
  subtitle?: string
  image?: string
  buttonClick?(): void
  buttonName?: string
  customButton?: React.ReactNode
  width?: number
  height?: number
  className?: string
  titleClassName?: string
  subtitleClassName?: string
}

function NotFoundTitle({ title, subtitle, image = "/assets/images/empty_table.png", buttonClick, buttonName, customButton, width, height, titleClassName="font-medium", subtitleClassName, className = "mt-12 p-4 sm:p-0" }: NotFoundTitleProps) {
  return (
    <div className={`${className} flex flex-col items-center justify-center`}>
      <Image 
        src={image}
        alt="not-available"
        width={width || 406}
        height={height || 306}
        objectFit="cover"
        />
      <Text customClass={titleClassName} alignText="center">
        {title}
      </Text>
      {subtitle &&
        <Text customClass={subtitleClassName} alignText="center">
          {subtitle}
        </Text>
      }
      {buttonName &&
        <Button customClass="mt-4" variant="contained" color="primary" onClick={buttonClick}>
          {buttonName}
        </Button>
      }
      {customButton}
    </div>
  )
}

export default NotFoundTitle
